<script setup>
import { computed } from 'vue';
import { Badge } from 'next/polaris/ui/badge';

const props = defineProps({
  label: {
    type: [Object, String],
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  // Kept for callers; the kit look carries the label's color only on the dot, not on the chip.
  // eslint-disable-next-line vue/no-unused-properties
  color: {
    type: String,
    default: 'slate',
    validator: value =>
      ['slate', 'amber', 'teal', 'ruby', 'blue', 'iris'].includes(value),
  },
});

const isStringLabel = computed(() => typeof props.label === 'string');

const labelTitle = computed(() => {
  return isStringLabel.value ? props.label : props.label?.title;
});

const labelDescription = computed(() => {
  return (!isStringLabel.value && props.label?.description) || '';
});

const labelColor = computed(() => {
  return isStringLabel.value ? null : props.label.color;
});
</script>

<template>
  <Badge
    variant="outline"
    :title="labelDescription"
    class="gap-1.5 text-polaris-foreground"
    :class="compact ? 'h-5 px-1.5' : 'h-6 px-2'"
  >
    <span
      v-if="labelColor"
      class="size-2 shrink-0 rounded-full"
      :style="{ background: labelColor }"
      aria-hidden="true"
    />
    <slot v-else name="icon" />
    <span class="whitespace-nowrap">{{ labelTitle }}</span>
    <slot name="action" />
  </Badge>
</template>
